import { useTranslation } from 'react-i18next';

const featureKeys = [
  { titleKey: 'feature1_title', descKey: 'feature1_desc', icon: 'ri-stack-line', color: '#C8714A' },
  { titleKey: 'feature2_title', descKey: 'feature2_desc', icon: 'ri-leaf-line', color: '#5a8a5a' },
  { titleKey: 'feature3_title', descKey: 'feature3_desc', icon: 'ri-shield-check-line', color: '#4a7a9b' },
  { titleKey: 'feature4_title', descKey: 'feature4_desc', icon: 'ri-tools-line', color: '#9b6a4a' },
];

export default function FeaturesSection() {
  const { t } = useTranslation();

  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full border border-[#e0d8d0] text-[#888] text-xs font-medium mb-4 tracking-widest">
            {t('features_badge')}
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-[#1a1a1a] leading-tight mb-4">
            {t('features_title')}
          </h2>
          <p className="text-[#888] text-sm md:text-base max-w-lg mx-auto">
            {t('features_desc')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featureKeys.map((feature) => (
            <div
              key={feature.titleKey}
              className="group p-6 rounded-2xl border border-[#f0ebe4] bg-[#faf8f5] hover:bg-[#C8714A] transition-all duration-300 cursor-default"
            >
              <div
                className="w-12 h-12 flex items-center justify-center rounded-xl mb-5 transition-colors duration-300"
                style={{ backgroundColor: `${feature.color}18` }}
              >
                <i
                  className={`${feature.icon} text-xl transition-colors duration-300 group-hover:text-white`}
                  style={{ color: feature.color }}
                ></i>
              </div>
              <h3 className="text-base font-bold text-[#1a1a1a] group-hover:text-white mb-3 transition-colors duration-300">
                {t(feature.titleKey)}
              </h3>
              <p className="text-sm text-[#888] group-hover:text-white/80 leading-relaxed transition-colors duration-300">
                {t(feature.descKey)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
